import './facetErrorMessage.scss';
import {HibuFacetErrorCode} from './facetTypes';
import {useTranslation} from 'react-i18next';

export type FacetErrorMessageProps = {
    errorCode: HibuFacetErrorCode;
};

export const FacetErrorMessage = ({errorCode}: FacetErrorMessageProps) => {
    const {t} = useTranslation();
    switch (errorCode) {
        case HibuFacetErrorCode.OVERFLOW_FACET_COUNT:
            return <div className={'facet-error'}>
                <div className={'facet-error-text'}>
                    {t('facets.errors.overflow')}
                </div>
            </div>;
        default:
            return <></>;
    }
};
